import React, { useEffect, useState } from "react";
import ToLogin from '../misc/Redirect/ToLogin';
import { useGlobalContext } from "../../pages/shared/context/global.context";
import { getComercioById } from "../../pages/Home/Services/comercio.service";
import { getHeader } from "../../pages/shared/services/header.service";
import { apiLogout } from "../../pages/shared/services/logout.service";

interface datosCabecera {
    nombre: string,
    empresa: string
}

interface state {
    cabecera?: datosCabecera,
    isRedirect: boolean,
    //loading: boolean,
    url: string
}

const Header = () => {
    const {comercioSelecionado,setComercioSelecionado,setUserSessionModulo,setUserLogged} = useGlobalContext()
    const [loading,setLoading] = useState(true)
    const [state, setState] = useState<state>({ cabecera: undefined, isRedirect: false, url: "" });

    useEffect(() => {
        populateHeaderData();
    }, [])


    async function populateHeaderData() {
        const {data,status} = await getHeader()
        setLoading(false)
        setState({ ...state, cabecera: data });
        setUserSessionModulo(data.modulo)
        setUserLogged(data)
        if(data.comercio && comercioSelecionado.length === 0){
            searchComercio(data.comercio)
        }
        
    }
    const searchComercio =  async (idComercio:string) =>  {
        const {data,status} = await getComercioById(idComercio)
        if(status === 200){
            setComercioSelecionado(data.comercios)
        }else{
           //toast.current?.show({life: 5000, severity: 'error', summary: 'Message', detail: `El Comercio ${idComercio} no existe`});
        }
    }

    async function onLogout() {
        const {data,status} = await apiLogout()
        if(status === 200){
            setState({
                ...state,
                isRedirect: true, url: data.nologin
            });
        }
    }
     
        if (state.isRedirect) {
            return <ToLogin url={state.url} titulo="Sesión" mensaje="En unos segundos será redirigido a la pantalla de Login." />
        }
        else if (loading) {
            return (
                <header className="n3 c3" style={{fontSize:'12px', height: '2.5rem'}}>
                    <p>ARGENTINA</p>
                </header>)
        }
        else {
            if (comercioSelecionado.length > 0 ) {
                return (
                    <header className="layout-header" style={{fontSize:'12px', height: '2.5rem'}}>
                        <p>ARGENTINA</p>
                        <div className="d-flex"  style={{right: '0', position: 'absolute'}}>
                            {state.cabecera != undefined ?
                                <div className="row pr-4">
                                    <span>{state.cabecera.nombre}</span>
                                    <span className="ml-2 mr-2">|</span>

                                    <span className="ml-2 mr-2">Comercio: {comercioSelecionado[0].comercioId} {comercioSelecionado[0].comercioId ? '-': 'N/D'} {comercioSelecionado[0].nombreFantasia} </span>

                                    <span className="ml-2 mr-2">|</span>
                                    <a onClick={onLogout} style={{ cursor: 'pointer' }}>{"Cerrar Sesión"}</a>
                                </div>
                                :
                                <div>
                                </div>
                            }
                        </div>
                    </header >
                )
            }
            else {
                return (
                    <header className="layout-header" style={{fontSize:'12px', height: '2.5rem'}}>
                        <p>ARGENTINA</p>
                        <div className="d-flex" style={{right: '0', position: 'absolute'}}>
                            {state.cabecera != undefined ?
                                <div className="row pr-4">
                                    <span>{state.cabecera.nombre}</span>
                                    <span className="ml-2 mr-2">|</span>

                                    <span className="ml-2 mr-2">Comercio: {'N/D'}</span>

                                    <span className="ml-2 mr-2">|</span>
                                    <a onClick={onLogout} style={{ cursor: 'pointer' }}>{"Cerrar Sesión"}</a>
                                </div>
                                :
                                <div>
                                </div>
                            }
                        </div>
                    </header >
                    )
            }
            
            
        }
    }

 export default Header